module.exports = {
  pathPrefix: `/book/arewethereyet`,
  siteMetadata: {
    title: `Are We There Yet?`,
    description: `Computers and the Teaching of Writing in American Higher Education–Twenty Years Later`,
    author: `@SchmidtNikolas`,
  },
  plugins: [
    `gatsby-plugin-react-helmet`,
    `gatsby-plugin-twitter`,
    `gatsby-plugin-netlify-cms`,
    {
      resolve: `gatsby-source-filesystem`,
      options: {
        name: `images`,
        path: `${__dirname}/src/images`,
      },
    },
    {
    resolve: `gatsby-source-filesystem`,
      options: {
        name: `chapters`,
        path: `${__dirname}/chapters/`,
      },
    },
    {
    resolve: `gatsby-source-filesystem`,
      options: {
        name: "standalone",
        path: `${__dirname}/standalone/`,
      },
    },
    {
    resolve: `gatsby-source-filesystem`,
      options: {
        name: "landing_page",
        path: `${__dirname}/landing/`,
      },
    },
    {
    resolve: `gatsby-source-filesystem`,
      options: {
        name: "navbar",
        path: `${__dirname}/navbar/`,
      },
    },
    {
    resolve: `gatsby-source-filesystem`,
      options: {
        name: "conferences",
        path: `${__dirname}/archives/conferences`,
      },
    },
    {
    resolve: `gatsby-source-filesystem`,
      options: {
        name: `data`,
        path: `${__dirname}/keywords/`,
      },
    },
    {
       resolve: `gatsby-transformer-remark`,
       options: {
         footnotes: true,
         plugins: [
           {
             resolve: "gatsby-remark-external-links",
               options: {
                 target: "_blank",
                 rel: "nofollow noopener noreferrer"
               }
           },
         ]
       },
     },
    `gatsby-transformer-sharp`,
    `gatsby-plugin-sharp`,
    {
      resolve: `gatsby-plugin-manifest`,
      options: {
        name: `AreWeThereYet`,
        short_name: `AreWeThereYet`,
        start_url: `/`,
        background_color: `#3A4266`,
        theme_color: `#3A4266`,
        display: `minimal-ui`,
        icon: `src/images/favicon.png`, // This path is relative to the root of the site.
      },
    },
    `gatsby-transformer-json`,
    {
      resolve: `gatsby-source-filesystem`,
      options: {
        name: `data`,
        path: `${__dirname}/data`
      }
    }
    // this (optional) plugin enables Progressive Web App + Offline functionality
    // To learn more, visit: https://gatsby.dev/offline
    // `gatsby-plugin-offline`,
  ],
}
